/* Oralux advertorial — countdown + before/after carousel. Idempotent, re-inits in the theme editor. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initClock(root) {
    (root || document).querySelectorAll('.hpr-holiday-clock').forEach(function (clock) {
      if (clock.__oxaClock) return;
      clock.__oxaClock = true;
      var hoursEl = clock.querySelector('#js-clock-hours, [data-clock-hours]');
      var minsEl = clock.querySelector('#js-clock-minutes, [data-clock-minutes]');
      var secsEl = clock.querySelector('#js-clock-seconds, [data-clock-seconds]');
      var span = parseInt(clock.getAttribute('data-hours') || '24', 10);
      if (!hoursEl || !minsEl || !secsEl) return;
      var key = 'oxa-cd-' + (clock.getAttribute('data-key') || 'default');
      var end = parseInt(localStorage.getItem(key) || '0', 10);
      var now = Date.now();
      if (!end || end < now) { end = now + span * 3600 * 1000; try { localStorage.setItem(key, end); } catch (e) {} }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var t = Math.floor(diff / 1000);
        var h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
        hoursEl.textContent = pad(h); minsEl.textContent = pad(m); secsEl.textContent = pad(s);
        if (diff <= 0) { end = Date.now() + span * 3600 * 1000; try { localStorage.setItem(key, end); } catch (e) {} }
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initCarousel(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (car) {
      if (car.__oxaCar) return;
      car.__oxaCar = true;
      var track = car.querySelector('[data-carousel-track]');
      var prev = car.querySelector('[data-carousel-prev]');
      var next = car.querySelector('[data-carousel-next]');
      var dotsWrap = car.querySelector('[data-carousel-dots]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
      function current() {
        var c = track.scrollLeft, best = 0, bd = Infinity;
        slides.forEach(function (sl, i) {
          var d = Math.abs(sl.offsetLeft - track.scrollLeft - track.clientLeft);
          if (d < bd) { bd = d; best = i; }
        });
        return best;
      }
      function sync() {
        var i = current();
        dots.forEach(function (d, k) { d.classList.toggle('hpr-is-active', k === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      track.addEventListener('scroll', function () { window.clearTimeout(track.__t); track.__t = window.setTimeout(sync, 80); });
      // drag to slide (mouse)
      var down = false, sx = 0, sl = 0;
      track.addEventListener('mousedown', function (e) { down = true; sx = e.pageX; sl = track.scrollLeft; track.style.cursor = 'grabbing'; });
      window.addEventListener('mouseup', function () { down = false; track.style.cursor = ''; });
      track.addEventListener('mousemove', function (e) { if (!down) return; e.preventDefault(); track.scrollLeft = sl - (e.pageX - sx); });
      sync();
    });
  }

  function initVideos(root) {
    var vids = (root || document).querySelectorAll('.oxa video');
    if (!vids.length) return;
    var tryPlay = function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) tryPlay(e.target); else { try { e.target.pause(); } catch (x) {} }
        });
      }, { threshold: 0.15 });
      vids.forEach(function (v) { if (!v.__oxaVid) { v.__oxaVid = true; io.observe(v); tryPlay(v); } });
    } else {
      vids.forEach(function (v) { if (!v.__oxaVid) { v.__oxaVid = true; tryPlay(v); } });
    }
  }
  function initAll(root) { initClock(root); initCarousel(root); initVideos(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
